var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2528_2226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4767 1.07617H5.09538C3.11402 1.07617 1.50781 2.68238 1.50781 4.66374V10.0451C1.50781 12.0264 3.11402 13.6327 5.09538 13.6327H10.4767C12.4581 13.6327 14.0643 12.0264 14.0643 10.0451V4.66374C14.0643 2.68238 12.4581 1.07617 10.4767 1.07617Z",
    stroke: "white",
    strokeWidth: 1.16597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79224 10.0454C6.30618 10.0454 5.10156 8.8408 5.10156 7.35474C5.10156 5.86868 6.30618 4.66406 7.79224 4.66406C9.2783 4.66406 10.4829 5.86868 10.4829 7.35474C10.4829 8.06831 10.1994 8.75273 9.69482 9.25732C9.19023 9.76191 8.50581 10.0454 7.79224 10.0454Z",
    stroke: "white",
    strokeWidth: 1.16597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3742 3.31844C11.1266 3.31844 10.9258 3.51922 10.9258 3.76689C10.9258 4.01456 11.1266 4.21533 11.3742 4.21533C11.6219 4.21533 11.8227 4.01456 11.8227 3.76689C11.8227 3.51922 11.6219 3.31844 11.3742 3.31844Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.582985,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2528_2226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3503,
    height: 14.3503,
    fill: "white",
    transform: "translate(0.429688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5446e462ddf9059b6902cd6b7bc2ab11.svg";
export { ForwardRef as ReactComponent };